<template>
  <el-select
    v-model="selected"
    style="width: 100%"
    :clearable="clearable"
    :disabled="disabled"
    @change="onChange"
  >
    <el-option
      v-for="item in items"
      :key="item"
      :label="enumFilter(name, item)"
      :value="item"
    />
  </el-select>
</template>

<script>
import { enumFilter } from "@/utils/filters";

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultValue: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      props: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      },
    };
  },
  computed: {
    options() {
      return Array.isArray(this.data) ? this.data : [];
    },
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    if (this.defaultValue) this.selected = this.defaultValue;
  },
  methods: {
    enumFilter,
    onChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
